import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

const roleDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  description: z.string().nullable(),
  isSystem: z.boolean(),
  permissionCodes: z.array(z.string()),
});

export type RoleOption = z.infer<typeof roleDtoSchema>;

export function useRoleOptions() {
  const tenantId = useTenantStore((s) => s.tenantId);

  return useQuery({
    queryKey: ['roles', 'list', tenantId],
    queryFn: async ({ signal }) => {
      const raw = await apiClient.get(`api/v1/t/${tenantId}/roles`, { signal }).json();
      return z.array(roleDtoSchema).parse(raw);
    },
    enabled: !!tenantId,
    staleTime: 30_000,
  });
}
